import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useApp, gTagSet, Loading } from "@laboratoria/sdk-react";
import RoutesWithIntl from "./RoutesWithIntl";

const App = () => {
  const [defaultLang, setDefaultLang] = useState();

  useEffect(() => {
    setDefaultLang(navigator.language.split("-")[0] === "pt" ? "pt" : "es");
  }, []);

  if (defaultLang === undefined) {
    return <Loading />;
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <Navigate to={`/${defaultLang}/${window.location.search}`} />
          }
        />
        <Route
          path="/:lang/*"
          element={
            <RoutesWithIntl defaultLang={defaultLang} />
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
